import { isUserLoggedIn, getUserData, getAccessToken } from "@/auth/utils";

export default {
  accessToken: getAccessToken(),
  user: getUserData(),
  isUserLoggedIn: isUserLoggedIn(),
};
